import { Component, OnInit ,Input} from '@angular/core';
import { ModalController, } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable'; //search en select
import * as firebase from 'firebase';
import { LoadingController ,AlertController} from '@ionic/angular';
import{ServiciodeAfesMultiplesService} from '../serviciode-afes-multiples.service'
import {ServiciodepedidovigenteService} from '../serviciodepedidovigente.service'
import { from } from 'rxjs';


//search en select
class Afe {
  public id: number;
  public name: string;
  public codigo: string;
  public proyecto: string;
  public codigoCompania: string;
  public afeNIT: string;
  public area: string;
  
}

@Component({
  selector: 'app-modal-editar-afes',
  templateUrl: './modal-editar-afes.page.html',
  styleUrls: ['./modal-editar-afes.page.scss'],
})
export class ModalEditarAfesPage implements OnInit {

    // "value" passed in componentProps
    @Input() pedidoseleccionado;


  afe;
  codigoCompania=''
  afeNIT=''
  area=''

  //contenidos de seleccion multiple
  arraydeafes = [];
  cursordeafes;

    //search select AFE
listadeafes: Afe[];
objetodeafe: Afe;

  constructor(public alertController:AlertController, public referencialservicio:ServiciodepedidovigenteService, public alerta:AlertController,  public loadingController: LoadingController, public modalController: ModalController, public ServiciodeAfesMultiples:ServiciodeAfesMultiplesService) {
    this.listadeafes = [];
   }

  ngOnInit() {

  }

  onAFESelectableOpen(event: { component: IonicSelectableComponent }) {
    this.loadingController.dismiss();
  }

  //search select
  afeChange(event: {
    component: IonicSelectableComponent,
    value: any 
  }) {
    this.afe = event.value.codigo+" - "+event.value.proyecto;
    this.codigoCompania = event.value.codigoCompania 
    this.afeNIT = event.value.afeNIT
    this.area = event.value.area

    // this.proyecto = event.value.proyecto
  }



  asignar(){
    this.updatefirebase({
      afe:this.afe,
      codigoCompania: this.codigoCompania, 
      afeNIT: this.afeNIT,
      area: this.area

    },(respuestadecallback)=>{
      if(respuestadecallback == "OK"){
        this.alertagenerica("AFE Actualizado","¡El nuevo AFE ha sido asignado con éxito!");
        this.modalController.dismiss();
      }else
      if(respuestadecallback != "OK")
      this.alertagenerica ("Hubo un error",respuestadecallback)
      this.modalController.dismiss();
    })
  }

  async alertagenerica( header, mensaje) {
    const alert = await this.alertController.create({
      header: header,
      message: mensaje,
      buttons: [
         {
          text: 'OK!',
          handler: () => {
            console.log('Confirm Okay');
          }
        }
      ]
    });
    await alert.present();
  }

  updatefirebase(objetoparaupdate, callback) {
    //aqui va el update de firebase:
    firebase.firestore().collection("posts").doc(this.pedidoseleccionado.id).update(objetoparaupdate).then(() => {
      //fin de update de firebase
      callback("OK");
    }).catch((err) => {
      //si hay error en firebase:
      callback(err);
    })
  }



  cargaAfes(){
    this.presentLoading();
    this.arraydeafes = [];
    this.listadeafes = [];
    this.cursordeafes = 0;
     //QUERY DE AFES
     let querydeafes = firebase.firestore().collection("afes").where("activo","==",true);
     querydeafes.get().then((docs) => {
       docs.forEach((doc) => {
         this.arraydeafes.push(doc);
         console.log("arraydeafes: " + this.arraydeafes);
         
         this.listadeafes.push( { id:this.arraydeafes.length-1 , name: doc.data().codigoafe+" - "+doc.data().proyecto, codigo: doc.data().codigoafe, proyecto:doc.data().proyecto, codigoCompania:doc.data().codigoCompania, afeNIT:doc.data().afeNIT,area:doc.data().area } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
  
       });
       this.cursordeafes = this.arraydeafes[this.arraydeafes.length - 1];
  
       this.loadingController.dismiss()
     
     }).catch((err) => {
       console.log(err);
     });
  }


  async presentLoading() {
    const loading = await this.loadingController.create({
      message: 'Cargando items...',
      // duration: 6000
    });
    await loading.present();
  
    const { role, data } = await loading.onDidDismiss();
  
    console.log('Loading dismissed!');
  }



}
